export const COMMAND_PALETTE_CONTAINER_TEST_ID =
	'shared-layout.ui.global.command-palette-container';
